import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const FeatureWheelSectionContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  .feature-wheel--desktop-content-container {
    display: flex;
    padding: 130px 28px;
    overflow: hidden;

    .feature-wheel--content-container {
      min-width: 412px;
      max-width: 412px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .feature-wheel--ctas {
        margin: 30px 0 0 0;
        justify-content: flex-start;
      }

      .feature-wheel--content-content {
        margin-top: 55px;
        min-height: 230px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .feature-wheel--content-feature-title {
          color: var(--normal-title-color);
        }

        .feature-wheel--content-feature-description {
          margin-top: 15px;
          font-size: 20px;
        }
        .feature-wheel--content-feature-link {
          margin-left: 30px;

          a {
            font-size: 20px;
            color: var(--neutral-7);
          }
        }
      }

      .feature-wheel--arrow-container {
        display: flex;
        justify-content: flex-end;
        margin-top: 30px;

        .feature-wheel--arrow-item {
          width: 60px;
          height: 60px;
          border: 1px solid #e5ebee;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          svg {
            width: 20px;
            height: 20px;

            path {
              stroke: #354f5b;
            }
          }

          &.arrow-prev {
            margin-right: 20px;
            padding-right: 3px;

            svg {
              transform: scale(-1);
            }
          }

          &.arrow-next {
            padding-left: 5px;
          }

          &:hover {
            border: 1px solid var(--secondary-color);
          }
        }
      }
    }

    .feature-wheel--wheel-container {
      width: 100%;
      padding: 0 0 0 100px;
    }
  }

  .feature-wheel--mobile-content-container {
    display: none;
  }

  @media (max-width: 768px) {
    .feature-wheel--desktop-content-container {
      .feature-wheel--content-container {
        min-width: 300px;
        max-width: 300px;

        .feature-wheel--content-title {
          font-size: 29px;
        }

        .feature-wheel--content-content {
          margin-top: 35px;

          .feature-wheel--content-feature-title {
            font-size: 20px;
          }

          .feature-wheel--content-feature-description {
            font-size: 17px;
          }

          .feature-wheel--content-feature-link {
            font-size: 17px;
          }
        }

        .feature-wheel--arrow-container {
          .feature-wheel--arrow-item {
            width: 45px;
            height: 45px;

            svg {
              width: 15px;
              height: 15px;
            }

            &.arrow-next {
              padding-left: 2px;
            }
          }
        }
      }

      .feature-wheel--wheel-container {
        padding-left: 50px;
      }
    }
  }

  @media (max-width: 576px) {
    .feature-wheel--desktop-content-container {
      display: none;
    }

    .feature-wheel--mobile-content-container {
      display: block;
    }
  }

  .feature-wheel--ctas {
    display: flex;
    margin: 30px 0;
    align-items: center;
    justify-content: center;
  }

  .feature-wheel--mobile-content-container {
    width: 100%;
    padding: 130px 0;

    .feature-wheel--content-title {
      font-size: 29px;
      text-align: center;
      padding: 0 24px;
      justify-content: center;
    }

    .feature-wheel--wheel-slick {
      margin-top: 43px;

      .feature-wheel--icon-slider {
        .slick-slide {
          .feature-wheel--icon-slider-item {
            width: 100%;
            height: 120px;

            .feature-wheel--item-icon {
              width: 60px;
              height: 60px;
              transition: all 0.5s;
              margin: 0 auto;
            }
          }

          &.slick-center {
            .feature-wheel--icon-slider-item {
              .feature-wheel--item-icon {
                width: 120px;
                height: 120px;
              }
            }
          }
        }
      }

      .feature-wheel--content-slider {
        padding: 0 20px;
        margin-top: 35px;
        text-align: center;

        .feature-wheel--content-slider-item {
          .feature-wheel--content-feature-title {
            font-size: 20px;
            color: var(--normal-title-color);
          }

          .feature-wheel--content-feature-description {
            font-size: 17px;
            margin-top: 18px;
          }

          .feature-wheel--content-feature-link {
            display: block;
            font-size: 17px;
            color: var(--neutral-7);
            margin-left: 30px;
          }
        }

        .slick-dots {
          width: calc(100% - 40px);
          bottom: -35px;

          li {
            margin: 0;
            width: 15px;

            button {
              padding: 0;
              width: 15px;

              &:before {
                width: 15px;
                font-size: 10px;
                opacity: 1;
                color: #cfd8dc;
              }
            }

            &.slick-active {
              button {
                &:before {
                  color: var(--secondary-color);
                }
              }
            }
          }
        }

        .slick-arrow {
          bottom: -55px;
          position: absolute;
          top: auto;
          width: 35px;
          height: 35px;
          border-radius: 50%;
          border: 1px solid #f6f8fa;
          box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
          display: flex !important;
          align-items: center;
          justify-content: center;
          z-index: 101;

          &:before {
            content: none;
          }

          svg {
            width: 15px;
            height: 15px;
          }

          &.slick-prev {
            left: 20px;

            svg {
              transform: scale(-1);
            }
          }

          &.slick-next {
            right: 20px;
          }
        }
      }
    }
  }
`;
